import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getDispatchList } from '@/api/order';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import Inr from '@/components/Inr/index.vue';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.BASE_URL = process.env.VUE_APP_BASE_API;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.dateRange = '';
    this.startDate = '';
    this.endDate = '';
    this.listQuery = {
      page: 1,
      limit: 10
    };
  }
  activated() {
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await getDispatchList(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    if (this.dateRange) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
      this.listQuery.orderTimestamp = [this.startDate, this.endDate].join(',');
    } else {
      this.listQuery.orderTimestamp = '';
    }
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  async dateval() {
    this.getList();
  }
  async handleDownload() {
    const orderFilter = Object.assign({}, this.listQuery);
    delete orderFilter.limit;
    delete orderFilter.page;
    this.downloadLoading = true;
    const tHeader = ['Product', 'Variation', 'Quantity'];
    const filterVal = ['product_name', 'pv_name', 'quantity'];
    if (this.dateRange) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
      var exportData = await getDispatchList({
        startDate: this.startDate,
        endDate: this.endDate
      });
      const data = formatJson(filterVal, exportData.data);
      exportJson2Excel(tHeader, data, this.$tc('route.orderManagement.orders.dispatch'));
      this.downloadLoading = false;
    } else {
      this.$message({
        type: 'info',
        message: 'Please select a date range'
      });
      this.downloadLoading = false;
    }
  }
};
default_1 = __decorate([Component({
  name: 'OrderDispatchList',
  components: {
    Pagination,
    Enabled,
    Inr
  }
})], default_1);
export default default_1;